import React from 'react'
export default class QuantityElement extends React.Component {
  constructor(props){
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.state={touched:false}
  }

componentDidMount(){
    let quantity = this.props.item.quantity
    if(quantity > 0) {
      quantity = Number(quantity)
       this.setState({quantity:quantity})
    }
}


componentWillReceiveProps(nextProps) {
  if(nextProps.item.quantity != this.props.item.quantity) {
    this.setState({quantity:Number(nextProps.item.quantity)})
  }
}

handleChange( e) {

  let item = this.props.item, key= "quantity", value=e.target.value
  this.setState({touched:true, quantity:value})
  item[key]= (value)
  this.props.onChangeCallback(item)
}

  render(){
    let quantity = this.props.item.quantity
    if(this.state.touched) {
      quantity = this.props.item.quantity
    }
    else {
      quantity = this.state.quantity
    }
    return <input name="quantity" type="text" className="form-control input-sm" value={quantity} onChange={this.handleChange} />
  }
}



// WEBPACK FOOTER //
// ./src/components/credit/rowelements/quantity.js